
import { Component, Vue } from "vue-property-decorator";
import { customerService } from "@/services/api/customers.service";
import { storageService } from "@/services/api/storage.service";
import { getModule } from "vuex-module-decorators";
import store from "@/store";
import OverlayModule from "@/store/modules/core/overlay.module";
import AuthModule from "@/store/modules/core/auth.module";
const authModule = getModule(AuthModule, store);
const overlayModule = getModule(OverlayModule, store);
const AppBar = () => import("@/components/core/AppBar.vue");
const AppFooter = () => import("@/components/core/AppFooter.vue");
const MessageDialog = () => import("@/components/core/MessageDialog.vue");

@Component({
  components: {
    AppBar,
    AppFooter,
    MessageDialog,
  },
})
export default class Categories extends Vue {
  // VARS
  private customersList = [];
  private categoriesCheckList = [];
  private chosenCustomer = "";
  private isLoadingButton = false;
  // VARS --- COMPONENTS
  private numberSelected = 0;
  private messageDialogOpen = false;
  private dialogText = "";

  private beforeCreate(): void {
    if (authModule.role != "0") {
      this.$router.push("/");
    }
  }
  // MOUNTED LOGIC
  mounted(): void {
    this.getUsers();
  }

  // --- METHODS: GET USERS LIST
  private getUsers(): void {
    customerService.getCustomers("", "").then((res) => {
      this.customersList = res.data;
    });
  }

  // --- METHODS: SEND EXCLUDED CATEGORIES
  private refreshList(choice): void {
    // Check if type of choice is "object". If not, do nothing (invalid choice from combobox)!
    if (typeof choice === "object") {
      if (choice.codiceCliente) {
        // Get via API
        overlayModule.showOverlay();
        storageService.getCustomerFilter(choice.codiceCliente).then((res) => {
          this.chosenCustomer = choice.codiceCliente;
          this.categoriesCheckList = res.data;
          overlayModule.hideOverlay();
        });
      } else {
        this.categoriesCheckList = [];
      }
    } else {
      this.categoriesCheckList = [];
    }
  }

  // --- METHODS: TOGGLE ALL CHECKBOXES
  private toggleAll(): void {
    if (this.categoriesCheckList.find((item) => !item.disabled)) {
      this.categoriesCheckList.forEach((item) => (item.disabled = true));
    } else {
      this.categoriesCheckList.forEach((item) => (item.disabled = false));
    }
  }

  // --- METHODS: SEND EXCLUDED CATEGORIES
  private sendValue(): void {
    this.isLoadingButton = true;
    //  get values
    let checkedArray = [];
    this.categoriesCheckList.forEach((item) => {
      if (item.disabled) {
        checkedArray.push(item.value);
      }
    });
    // send via API
    let itemToSend = {
      CodiceCliente: this.chosenCustomer,
      Art_Categoria: checkedArray,
    };
    customerService
      .excludeCustomer(itemToSend)
      .then((res) => {
        // show modal
        if (res.status === 200) {
          this.dialogText = "Categorie da mostrare modificate correttamente!";
          this.messageDialogOpen = true;
          this.isLoadingButton = false;
        } else {
          errorHandling();
        }
      })
      .catch((e) => {
        console.warn(e);
        errorHandling();
      });

    let errorHandling = (): void => {
      this.dialogText = "Non è stato possibile modificare le categorie!";
      this.messageDialogOpen = true;
      this.isLoadingButton = false;
    };
  }
}
